import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import DirectoryPage from "./pages/DirectoryPage";
import MyStoryPage from "./pages/MyStoryPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import HowItWorksPage from "./pages/HowItWorksPage";
import ResourcesPage from "./pages/ResourcesPage";
import PricingPage from "./pages/PricingPage";
import ContactPage from "./pages/ContactPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import Preloader from "./components/Preloader";
import ChatbotWidget from "./components/ChatbotWidget";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

function AppRoutes() {
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const timer = window.setTimeout(() => setLoading(false), 2000);
        return () => window.clearTimeout(timer);
    }, [location.pathname]);

    // Scroll to top on route change (unless navigating to a hash section)
    useEffect(() => {
        if (loading || location.hash) {
            return;
        }
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [loading, location.pathname, location.hash]);

    useEffect(() => {
        if (loading || !location.hash) {
            return;
        }
        const id = location.hash.slice(1);
        if (!id) {
            return;
        }
        const element = document.getElementById(id);
        if (!element) {
            return;
        }
        const frame = requestAnimationFrame(() => {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        });
        return () => cancelAnimationFrame(frame);
    }, [loading, location.hash]);

    if (loading) {
        return (
            <div className="bg-background text-foreground min-h-screen flex flex-col">
                <Navbar />
                <main className="flex-1">
                    <Preloader />
                </main>
                <Footer />
            </div>
        );
    }

    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Navigate to="/#features" replace />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/my-story" element={<MyStoryPage />} />
            <Route path="/directory" element={<DirectoryPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/delete-account" element={<DeleteAccountPage />} />
            <Route path="/delete-account-request" element={<Navigate to="/delete-account" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <ChatbotWidget />
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
        </div>
    );
}

export default App;
